<template>
  <div>
    <v-autocomplete
        v-for="(item,index) in fields" :key="index"
        style="border-radius: 8px"
        dense
        :label="item.label"
        :items="item.items"
        clearable
        clear-icon="mdi-close-circle-outline"
        @click:clear="clearData(item.filterTitle)"
        item-text="title"
        @change="getValue(item.filterTitle,$event)"
        item-value="value"
        :menu-props="{offsetY: true}" outlined/>


  </div>
</template>

<script>
export default {
  name: "extraFilter",
  props: {
    fields: [],
    value: Object
  },
  data() {
    return {
      sendData: false
    }
  },
  watch: {
    value: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
    getData() {
      this.sendData = true;
      this.$emit('getInfo', this.sendData);
    },
    clearData(names) {
      this.sendData = true;
      this.value[names] = undefined;
      this.$emit('getInfo', this.sendData);
    },
    getValue(names, val) {
      this.value[names] = val;
    }
  }
}
</script>

<style scoped>

</style>